import React from "react";
import { inject, observer } from "mobx-react";
import FeedbackStore from "../../stores/FeedbackStore";
import { Alert, List } from "@op/opds.opux";
import { Message } from "react-message-context";
import ErrorAction from "./ErrorAction";
import { focusAtElement } from "../../utils/commonUtils";

const ErrorSummary = observer(
  class ErrorSummary extends React.Component {
    componentDidMount() {
      focusAtElement("#ROF-errors");
    }

    render() {
      const { invalidFields } = FeedbackStore;

      if (invalidFields.length === 0) return null;

      return (
        <Alert
          id="ROF-errors"
          className="rof-errorSummary"
          tabIndex={-1}
          type="critical"
          role=""
          contentType="static"
        >
          <h2 className="opux-v6__ds-alert__title rof-errorSummary__title">
            <Message
              id="feedback.errorSummary.title"
              count={invalidFields.length}
            />
          </h2>

          <List border="none" className="rof-errorSummary__list">
            {invalidFields.map((field, index) => (
              <ErrorAction
                key={field.key}
                index={index}
                error={field}
                errorCount={invalidFields.length}
              />
            ))}
          </List>
        </Alert>
      );
    }
  }
);

export default inject("FeedbackStore")(ErrorSummary);
